(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/match-number-icon/assets/javascripts/match-number-icon.js') >= 0) return;  svs.modules.push('/components/tipsen/match-number-icon/assets/javascripts/match-number-icon.js');
"use strict";

const Icon = svs.ui.ReactIcon;
const _svs$components$tipse = svs.components.tipsen.matchNumberIcon.constants,
  matchNumberTextColor = _svs$components$tipse.matchNumberTextColor,
  matchNumberIconSize = _svs$components$tipse.matchNumberIconSize;
const MatchNumberIcon = _ref => {
  let color = _ref.color,
    icon = _ref.icon,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? matchNumberIconSize.MEDIUM : _ref$size,
    text = _ref.text,
    _ref$textColor = _ref.textColor,
    textColor = _ref$textColor === void 0 ? matchNumberTextColor.WHITE : _ref$textColor;
  return React.createElement("div", {
    className: "pg_match_number_icon pg_match_number_icon--".concat(color, " pg_match_number_icon--").concat(size)
  }, React.createElement(Icon, {
    className: "pg_match_number_icon__icon",
    icon: icon
  }), text && React.createElement("span", {
    className: "pg_match_number__text pg_match_number__text--".concat(textColor)
  }, text));
};
setGlobal('svs.components.tipsen.matchNumberIcon.MatchNumberIcon', MatchNumberIcon);

 })(window);